import {PageLayout, UsersAdvancedTable} from '~/components'
import {SearchPageHeader} from '../search_header'
import {useHandleSearch, useFetchSearch, useSearchPlaceholderProps} from '../hooks'
import {Placeholder} from '~/components'
import {User} from '@eitje/api'

export const SearchUser = () => {
	const {handleChange, handleKeyDown, handleClear, searchValue, searchQuery} = useHandleSearch('user')

	const {searchResults, isLoading} = useFetchSearch({
		searchQuery,
		requiredRecords: ['environments', 'organisations'],
		model: User,
	})

	const placeholderProps = useSearchPlaceholderProps({searchResults, searchQuery, isLoading})

	return (
		<PageLayout
			name="users"
			headers={
				<SearchPageHeader
					headerLabel="common.users"
					count={searchResults.length}
					searchDropdownProps={{triggerText: 'common.users'}}
					searchInputProps={{searchValue, handleChange, handleKeyDown, handleClear}}
					searchExplanationPopoutProps={{title: 'user.search', body: 'user.popout.body'}}
				/>
			}
		>
			{placeholderProps ? <Placeholder {...placeholderProps} /> : <UsersAdvancedTable searchResults={searchResults} />}
		</PageLayout>
	)
}
